<template>
    <div class="wrap-bottom">Copyright © 2019 Trout & Partners, All Right Reserved.</div>
</template>

<script>
    export default {

    }
</script>

<style lang="less" rel="stylesheet">
    .wrap-bottom{
        height: 1rem;
        line-height: 1rem;
        font-size: .18rem;
        color: #2d2d2d;
        text-align: center;
    }
</style>
